<template>
  <div class="unit">
    <a-select
      style="width: 100%"
      v-model="select"
      @change="selectItem($event)"
      @dropdownVisibleChange="changeT"
      @blur="changeF"
    >
      <div slot="dropdownRender" slot-scope="menu">
        <v-nodes :vnodes="menu" />
        <a-divider style="margin: 4px 0" />
        <div class="addAcc" @mousedown="(e) => e.preventDefault()" @click="addItem">
          <a-icon type="plus" /> 添加账户
        </div>
      </div>
      <a-select-option v-for="item in items" :key="item" :value="item.id">
        <div class="max">
          <div class="max_l">
            <div class="l_name">{{ item.name }}</div>
            <div class="l_acc">{{ item.accountNum }}</div>
          </div>
          <div class="r_b">
            <div class="max_r" v-if="item.accountType == 1">支付宝</div>
            <div class="max_r" v-if="item.accountType == 2">个人银行卡</div>
            <div class="max_r" v-if="item.accountType == 3">对公银行账号</div>
            <span class="iconfont" v-show="bankshow" title="删除" @click="bankclear(item.id)">×</span>
          </div>
        </div>
      </a-select-option>
    </a-select>
    <a-modal v-model="is_revocation" title="添加账号" width="50%">
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="handleOk"> 提交 </a-button>
      </template>
      <div class="top">
        <div
          class="topItem"
          @click="changeItem(index)"
          :style="{ color: tIdx == index ? '#409EFF' : '' }"
          v-for="(item, index) in accs"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="center">
        <div class="c_item">
          <div class="title">户名：</div>
          <a-input class="aInput" v-model="form.name" allowClear placeholder="请输入"></a-input>
        </div>
        <div class="c_item">
          <div class="title">账号：</div>
          <a-input class="aInput" v-model="form.accountNum" allowClear placeholder="请输入"></a-input>
        </div>
        <div class="c_item" v-if="tIdx == 1 || tIdx == 2">
          <div class="title">银行：</div>
          <a-input class="aInput" v-model="form.bank" placeholder="请输入" allowClear></a-input>
        </div>
        <div class="c_item" v-if="tIdx == 2">
          <div class="title">地址：</div>
          <a-select class="selectAds" v-model="form.province" allowClear placeholder="请选择" @change="changePro">
            <a-select-option :value="item.id" v-for="(item, index) in pros" :key="index">
              {{ item.extName }}
            </a-select-option>
          </a-select>
          <a-select class="selectAds" :disabled="!form.province" v-model="form.city" allowClear placeholder="请选择">
            <a-select-option :value="item.id" v-for="(item, index) in cits" :key="index">
              {{ item.extName }}
            </a-select-option>
          </a-select>
        </div>
        <div class="c_item" v-if="tIdx == 2">
          <div class="title">银行支行：</div>
          <a-input class="aInput" v-model="form.branchBank" placeholder="请输入" allowClear></a-input>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  get_accounts_receivable,
  accounts_receivable_delete,
  get_list_enable,
  accounts_receivable_save,
} from '@/api/activiti'
export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      select: '',
      items: [],
      bankshow: true,
      is_revocation: false,
      accs: ['支付宝账号', '个人银行卡', '对公银行账号'],
      tIdx: 0,
      form: {
        name: '', //	户名
        accountNum: '', //	账号（卡号）
        bank: '', //	银行
        province: undefined, //	支行地址（省）
        city: undefined, //	支行地址（市）
        branchBank: '', //	银行支行
      },
      pros: [],
      cits: [],
    }
  },
  mounted() {
    this.get_lis()
    this.getAddres()
  },
  methods: {
    //   获取地址
    getAddres() {
      get_list_enable({
        deep: 0,
        pid: 0,
      }).then((res) => {
        this.pros = res.rows
        console.log(res)
      })
    },
    //切换省
    changePro() {
      get_list_enable({
        deep: 1,
        pid: this.form.province,
      }).then((res) => {
        this.form.city = undefined
        this.cits = res.rows
      })
    },
    get_lis() {
      get_accounts_receivable().then((res) => {
        this.items = res.data
      })
    },
    changeF() {
      this.bankshow = false
    },
    changeT() {
      this.bankshow = true
    },
    selectItem(e) {
      this.bankshow = false
      this.$emit('getPayRow', e)
    },
    //点击添加账号
    addItem() {
      this.is_revocation = true
    },
    //删除账号
    bankclear(id) {
      var that = this
      this.$confirm({
        title: '警告',
        content: '确认删除此账号?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          let list = []
          list.push(id)
          accounts_receivable_delete(list).then((res) => {
            if (res.code != 200) {
              that.$message.error(res.msg)
              return
            }
            that.$message.success('删除成功')
            that.get_lis()
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
      return
    },
    //切换类型
    changeItem(index) {
      this.tIdx = index
      this.form = {
        name: '', //	户名
        accountNum: '', //	账号（卡号）
        bank: '', //	银行
        province: undefined, //	支行地址（省）
        city: undefined, //	支行地址（市）
        branchBank: '', //	银行支行
      }
    },
    //提交地址
    handleOk() {
      var accountType = ''
      var obj = {}
      switch (this.tIdx) {
        case 0:
          accountType = 1
          obj = {
            name: this.form.name, //	户名
            accountNum: this.form.name,
          }
          break
        case 1:
          accountType = 2
          obj = {
            name: this.form.name, //	户名
            accountNum: this.form.name,
            bank: this.form.bank,
          }
          break
        case 2:
          accountType = 3
          obj = {
            name: this.form.name, //	户名
            accountNum: this.form.name,
            bank: this.form.bank,
            province: this.form.province,
            city: this.form.city,
            branchBank: this.form.branchBank,
          }
          break
      }
      var is = 0
      for (let k in obj) {
        if (!obj[k]) {
          is = 1
        }
      }
      if (is) {
        this.$message.error('请将' + this.accs[this.tIdx] + '信息填写完整')
        return
      }
      this.form['accountType'] = accountType
      accounts_receivable_save(this.form).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('提交成功')
        this.is_revocation = false
        this.get_lis()
      })
    },
  },
}
</script>
<style lang="less" scoped>
.unit {
  width: 100%;
  float: left;
}
.addAcc {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  cursor: pointer;
  color: #409eff;
}
.max {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.l_name {
  margin-right: 7px;
  font-weight: 600;
  color: #666;
  float: left;
}
.l_acc {
  float: left;
}
.r_b {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .iconfont {
    font-size: 24px;
    margin-left: 3px;
    color: #f56c6c;
    line-height: 30px;
  }
}
::v-deep .ant-select-selection-selected-value {
  width: 100%;
}
::v-deep .ant-modal-body {
  width: 100%;
  float: left;
}
.top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .topItem {
    float: left;
    margin-right: 25px;
    cursor: pointer;
    &:hover {
      color: #74b9fd;
    }
  }
}
.center {
  width: 80%;
  float: left;
  margin-top: 30px;
  .c_item {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
    .title {
      width: 90px;
      float: left;
      text-align: right;
    }
    .aInput {
      width: 300px;
    }
    .selectAds {
      width: 150px;
      float: left;
    }
  }
}
</style>
